module.exports = __webpack_public_path__ + "images/apple-touch-icon-152-2b2fbc88.png";